import { useRef, useState, useCallback } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getInitialWidth } from '@/redux/modules/windowSize';

import useWindowUpdateHelper from './useWindowUpdateHelper';

const useIsNarrowerThan = (width: number, initialSSRWidth?: number): boolean => {
    const initialWidth = useAppSelector(getInitialWidth);
    const effectiveInitialWidth = initialSSRWidth ?? initialWidth ?? 768;

    const isNarrowerRef = useRef(effectiveInitialWidth < width);
    const [isNarrowerThan, setIsNarrowerThan] = useState(effectiveInitialWidth < width);

    const handleWidthResize = useCallback(() => {
        const isNarrower = window.innerWidth < width;
        const isNarrowerHasChanged = isNarrowerRef.current !== isNarrower;
        if (isNarrowerHasChanged) {
            isNarrowerRef.current = isNarrower;
            setIsNarrowerThan(isNarrower);
        }
    }, [width]);

    useWindowUpdateHelper(handleWidthResize);

    return isNarrowerThan;
};

export default useIsNarrowerThan;
